import { IHttpRepository } from "Infrastructure/interfaces/IHttpRepository"
import { ICnpjRegisterRequestDTO, ICnpjRegisterResponseDTO, IUserRegiterResponseDTO } from "../interfaces/IUserRegiter"

export interface IUserRegisterService {
    getUserData: (localId: string, cpf: string) => Promise<IUserRegiterResponseDTO>
    getCompanyData: (localId: string, cnpj: string) => Promise<ICnpjRegisterResponseDTO>
}

const UserRegisterService = (httpRepository: IHttpRepository): IUserRegisterService => {

    const getUserData = async (localId: string, cpf: string) => {
        const response: IUserRegiterResponseDTO = await httpRepository.getAsync<IUserRegiterResponseDTO>(`/dispositivo/dadoscliente/${localId}/${cpf}`);
        return response
    }

    const getCompanyData = async (localId: string, cnpj: string) => {
        const requestBody: ICnpjRegisterRequestDTO = { cnpj, localId };
        const response: ICnpjRegisterResponseDTO = await httpRepository.postAsync<ICnpjRegisterRequestDTO, ICnpjRegisterResponseDTO>(
            `/ClienteEstabelecimento/Cnpj`,
            requestBody
        );
        return response;
    }


    return ({ getUserData, getCompanyData })
}
export default UserRegisterService